// Models
import { Temporal } from "temporal-polyfill-lite";
/**
 * Plan Calendar settings.
 */ export class Calendar {
    getClone() {
        // Temporal.PlainTime is immutable, so the references can be shared safely.
        return new Calendar({
            workDayDefaults: {
                startOfDay: this.workDayDefaults.startOfDay,
                endOfDay: this.workDayDefaults.endOfDay
            },
            timeZone: this.timeZone
        });
    }
    setProperty(key, value) {
        const clone = this.getClone();
        clone[key] = value;
        return clone;
    }
    forSerialization() {
        return {
            workDayDefaults: {
                startOfDay: this.workDayDefaults.startOfDay.toString(),
                endOfDay: this.workDayDefaults.endOfDay.toString()
            },
            timeZone: this.timeZone
        };
    }
    forCreate() {
        return this.forSerialization();
    }
    static fromResource(resource) {
        return new Calendar({
            workDayDefaults: {
                startOfDay: Temporal.PlainTime.from(resource.workDayDefaults.startOfDay),
                endOfDay: Temporal.PlainTime.from(resource.workDayDefaults.endOfDay)
            },
            timeZone: resource.timeZone
        });
    }
    constructor(propertyBag = {}){
        this.workDayDefaults = {
            startOfDay: propertyBag.workDayDefaults?.startOfDay ?? Calendar.DEFAULT_START_OF_DAY,
            endOfDay: propertyBag.workDayDefaults?.endOfDay ?? Calendar.DEFAULT_END_OF_DAY
        };
        this.timeZone = propertyBag.timeZone ?? Calendar.DEFAULT_TIMEZONE;
    }
}
Calendar.DEFAULT_START_OF_DAY = Temporal.PlainTime.from("09:00:00.0000000");
Calendar.DEFAULT_END_OF_DAY = Temporal.PlainTime.from("17:00:00.0000000");
Calendar.DEFAULT_TIMEZONE = "Etc/UTC";
